import { Playable2DRootContainer } from './core/Playable2DRootContainer';
import { PlayableLevel } from './game';
import '../public/index.less';
import { setLanguage } from './translate';
import { theme } from './theme';
import { GamePlaceholder } from 'components/GamePlaceholder';
import { Layout } from './LayoutManager';

import { loadMainAssets, isSupportWebP, preLoadGameAssets } from './preloadGameAssets';

import { GamePreloader } from './GamePreloader';
import { Store } from './store/gameStore';
import { getDifficultyDeals, getRandomDifficultyId, getSuit } from './deals';
import { BackgroundLevel } from 'components/gameBackground';
import { GameEvent } from './events/gameEvent';
import { EventName } from './events/eventsName';

export const gameContainerId = 'solitaire-container';
if (document.readyState === 'complete') {
    initGame();
} else {
    window.onload = initGame;
}

function initGame() {
    isSupportWebP(() => {
        setLanguage(document.documentElement.lang);

        new Playable2DRootContainer({ backgroundColor: theme.gameBackground });
        Layout.setLayout();
        new GamePlaceholder();
        let assetsLoaded = false;
        const preloader = new GamePreloader();
        getDifficultyDeals(Store.difficulty).then(async () => {
            //fetch deal id
            let lastGameId = Store.getPreviousGameId(Store.difficulty);

            if (!lastGameId) {
                lastGameId = await getRandomDifficultyId(Store.difficulty);
            }
            if (lastGameId) {
                Store.gameId = lastGameId;
            }

            preLoadGameAssets(() => {
                preloader.init();
                GameEvent.emit(EventName.SHOW_LOADER);
                new BackgroundLevel();

                loadMainAssets(() => {
                    assetsLoaded = true;
                    GameEvent.emit(EventName.HIDE_LOADER);

                    if (assetsLoaded) {
                        onLoad();
                    }
                });
            });
        });
    });
}

function onLoad() {
    new PlayableLevel();

    const canvases = document.getElementsByName('canvas');
    canvases.forEach((c) => {
        c.ontouchstart = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };
    });
    const gameContainer = document.getElementById(gameContainerId);
    if (gameContainer)
        gameContainer.oncontextmenu = function (event) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        };
}
